module.exports = {
	acl(user, defineAbility) {
		const ability = defineAbility((can, cannot) => {
			if (user.role === 'admin') {
				can('manage', 'Store');
			} else {
				cannot('manage', 'Store');
				can('read', 'Store', { id: { $in: user.storeIds } });
			}
		});

		return { ability };
	}
};
